export const TEXTS = {
  MORE_BUTTON_TEXT: (count: number) => `Ещё ${count}`,
  HIDE_BUTTON_TEXT: 'Свернуть',
};
